<template>
  <generic-modal :title="$t('edit order')" ref="generic_modal" :is_wide="true">
    <div v-if="meta && meta.billing && meta.shipping">
      <div class="title is-4 is-pulled-right">
        {{ $t("total") }} {{ format_currency(total) }}
      </div>
      <div class="title is-5">{{ $t("order") }} {{ meta.number }}</div>
      <div class="subtitle is-5 mb-5">
        {{ $t("status") }}:
        <span class="has-text-warning">{{ meta.status }}</span>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("status") }}</label>
            <div class="select">
              <select class="input" v-model="meta.status">
                <option value="pending">{{ $t("pending") }}</option>
                <option value="processing">{{ $t("processing") }}</option>
                <option value="on-hold">{{ $t("on hold") }}</option>
                <option value="completed">{{ $t("completed") }}</option>
                <option value="cancelled">{{ $t("cancelled") }}</option>
                <option value="refunded">{{ $t("refunded") }}</option>
                <option value="failed">{{ $t("failed") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("first name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.billing.first_name"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("last name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.billing.last_name"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="title is-5">{{ $t("billing") }}</div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.billing.email" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("phone") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.billing.phone" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("address") }} 1</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.billing.address_1"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("address") }} 2</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.billing.address_2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("city") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.billing.city" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("state") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.billing.state" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("post code") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.billing.postcode"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("country") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.billing.country" />
            </div>
          </div>
        </div>
      </div>

      <div class="title is-5">{{ $t("items") }}</div>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("quantity") }}</th>
            <th>{{ $t("price") }}</th>
            <th>{{ $t("total") }}</th>
            <th>{{ $t("options") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, iidx) in meta.line_items">
            <td>{{ item.name }}</td>
            <td>
              <input
                class="input"
                type="text"
                v-model="meta.line_items[iidx].quantity"
              />
            </td>
            <td>
              <input
                class="input"
                type="text"
                v-model="meta.line_items[iidx].price"
              />
            </td>
            <td>
              {{
                format_currency(
                  meta.line_items[iidx].quantity * meta.line_items[iidx].price
                )
              }}
            </td>
            <td>
              <div
                class="button is-small is-danger"
                @click="meta.line_items.splice(iidx, 1)"
              >
                <span class="icon">
                  <i class="fa fa-trash"></i>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="title is-5">{{ $t("delivery") }}</div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("first name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.shipping.first_name"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("last name") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.shipping.last_name"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("phone") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.shipping.phone" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("address") }} 1</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.shipping.address_1"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("address") }} 2</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.shipping.address_2"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("city") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.shipping.city" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("state") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.shipping.state" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("post code") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.shipping.postcode"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("country") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.shipping.country"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="save_order">
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "WooCommerceEditOrderModal",
  components: { GenericModal },
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  props: {},
  computed: {
    total() {
      let v = this;
      let total = 0;
      if (v.meta.line_items) {
        total = v.meta.line_items.reduce((acc, item) => {
          return acc + Number(item.quantity) * Number(item.price);
        }, 0);
      }

      return total;
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/woocommerce/order", { uuid: uuid })
        .then((order) => {
          v.meta = order.json_data;
          v.meta.mdl_uuid = uuid;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });

      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
    },
    save_order() {
      let v = this;
      v.$root.loader(true);
      let data = { ...v.meta };
      data.total = v.total;
      data.line_items = data.line_items.map((item) => {
        item.total = Number(item.quantity) * Number(item.price);
        return item;
      });
      post("/woocommerce/order", data)
        .then((order) => {
          v.$emit("order_updated");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
